type ConsentModeValue = 'denied' | 'granted';
type DataLayerEvent = Record<string, unknown> | IArguments;

declare global {
    interface Window {
        dataLayer?: DataLayerEvent[];
    }
}

export const pushDataLayerEvent = (event: DataLayerEvent): void => {
    if (typeof window === 'undefined') {
        return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(event);
};

const adsDenied = {
    ad_storage: 'denied' as ConsentModeValue,
    ad_user_data: 'denied' as ConsentModeValue,
    ad_personalization: 'denied' as ConsentModeValue,
};

function pushGoogleTagCommand(first: unknown, second: unknown, third: unknown): void {
    if (first === undefined || second === undefined || third === undefined) return;
    // Google Tag Manager expects the arguments object produced by gtag(), not a normal dataLayer event array.
    // eslint-disable-next-line prefer-rest-params
    pushDataLayerEvent(arguments);
}

export const shouldInitializeTagManager = ({
    adsMeasurementEnabled,
    advertisingConsent,
    analyticsConsent,
    authenticated,
}: {
    adsMeasurementEnabled: boolean;
    advertisingConsent: boolean;
    analyticsConsent: boolean;
    authenticated: boolean;
}): boolean => (adsMeasurementEnabled ? analyticsConsent && advertisingConsent : analyticsConsent || authenticated);

export const shouldReloadAfterOptionalConsentRevocation = ({
    adsMeasurementEnabled,
    advertisingConsent,
    analyticsConsent,
    previousAdvertisingConsent,
    previousAnalyticsConsent,
    tagManagerInitialized,
}: {
    adsMeasurementEnabled: boolean;
    advertisingConsent: boolean;
    analyticsConsent: boolean;
    previousAdvertisingConsent: boolean;
    previousAnalyticsConsent: boolean;
    tagManagerInitialized: boolean;
}): boolean =>
    adsMeasurementEnabled &&
    tagManagerInitialized &&
    ((previousAdvertisingConsent && !advertisingConsent) || (previousAnalyticsConsent && !analyticsConsent));

export const pushConsentModeDefault = (): void => {
    pushGoogleTagCommand('consent', 'default', {
        ...adsDenied,
        analytics_storage: 'denied' as ConsentModeValue,
    });
};

export const pushConsentModeUpdate = ({
    analyticsConsent,
    advertisingConsent,
}: {
    analyticsConsent: boolean;
    advertisingConsent: boolean;
}): void => {
    pushGoogleTagCommand('consent', 'update', {
        ad_storage: advertisingConsent ? 'granted' : 'denied',
        ad_user_data: advertisingConsent ? 'granted' : 'denied',
        ad_personalization: adsDenied.ad_personalization,
        analytics_storage: analyticsConsent ? 'granted' : 'denied',
    });
};
